<template lang="pug">
.mini-profile
  .mini-profile__header
    .mini-profile__avatar
      UiAvatar(
        :src="user.avatar"
        :label="user.name || user.email"
      )
    .mini-profile__info
      .mini-profile__name {{ user.name || `User #${user.id}` }}
      .mini-profile__email {{ user.email }}
  .mini-profile__body
    UiStack(spacing="sm")
      UiStackItem(
        grow
        shrink
      )
        UiButton(
          variant="ghost-secondary"
          block
          disabled
          icon="User"
        ) {{ $t("user.edit_profile") }}
      UiStackItem(
        grow
        shrink
      )
        UiButton(
          variant="ghost-secondary"
          block
          icon="LogOut"
          @click="logout"
        ) {{ $t("user.logout") }}
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["user"]),
  },

  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/stylesheet/_variables.scss";
@import "@/assets/stylesheet/_mixins.scss";

.mini-profile {
  min-width: 300px;
  overflow: hidden;
  border-radius: 10px;

  &__header {
    @include gradient-directional($bb-deep-green, $bb-grass-green, 135deg);
    padding: 20px;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    color: $white;
  }

  &__avatar {
    width: 60px;
    margin-right: 20px;
  }

  &__name {
    font-size: 16px;
    font-weight: 600;
  }

  &__email {
    font-size: 12px;
    color: rgba($white, 0.75);
  }

  &__body {
    padding: 10px;
  }
}
</style>
